import { Fragment, HTMLAttributes } from 'react'
import Link from 'next/link'

import Typography from './Typography'
import { cn } from '@/lib/utils'
import { WPYoastGraph } from '@/types'

export type Breadcrumbs = {
  name: string
  path: string
}
export type BreadcrumbsProps = HTMLAttributes<HTMLElement> &
  Partial<{ schema: WPYoastGraph[] }>

const Breadcrumbs = ({
  schema = [],
  className,
  ...props
}: BreadcrumbsProps) => {
  return (
    <span className={cn([className])} {...props}>
      {schema.map(({ item, name }, index) => (
        <Fragment key={index}>
          {index < schema.length - 1 ? (
            <>
              <Link href={item || '/'} className="inline-flex">
                <Typography variant="label" className="text-foreground">
                  {name}
                </Typography>
              </Link>
              <Typography variant="label" className="text-foreground">
                •
              </Typography>
            </>
          ) : (
            <Typography variant="label" className="text-heading">
              {name}
            </Typography>
          )}
        </Fragment>
      ))}
    </span>
  )
}

export default Breadcrumbs
